// Import Enums
import { BudgetPeriodTypeEnum, LimitBehaviorEnum } from 'enums';
// Import Constants
import l from './localizationLabels';

export const BUDGET_PERIOD_LABEL_KEYS: Record<BudgetPeriodTypeEnum, string> = {
    [BudgetPeriodTypeEnum.Day]: l.BudgetPeriodExecution,
    [BudgetPeriodTypeEnum.Week]: l.BudgetPeriodWeek,
    [BudgetPeriodTypeEnum.Month]: l.BudgetPeriodMonth,
    [BudgetPeriodTypeEnum.Year]: l.BudgetPeriodYear,
    [BudgetPeriodTypeEnum.Lifetime]: l.BudgetPeriodLifetime,
};

export const BUDGET_BEHAVIOR_LABEL_KEYS: Record<LimitBehaviorEnum, string> = {
    [LimitBehaviorEnum.Warn]: l.LimitBehaviorWarn,
    [LimitBehaviorEnum.WarnAndStop]: l.LimitBehaviorWarnAndStop,
};
